import React, { useState } from 'react'

const PROXY = process.env.REACT_APP_API_URL || ''
const API_KEY = process.env.REACT_APP_API_KEY || 'd1d30e16-2a11-4da0-a226-78ec3d8d850a'

const ContactUs = () => {
  const [email, setEmail] = useState('')
  const [message, setMessage] = useState('')
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [submitted, setSubmitted] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')

  const contactSubmit = (e) => {
    e.preventDefault()
    if (message.length > 500) {
      alert("Message can't be longer than 500 characters.")
      return
    }

    setIsSubmitting(true)
    setErrorMessage('')
    setSubmitted(false)

    const payload = JSON.stringify({ email, message })
    const headers = {
      'Content-Type': 'application/json',
      'X-API-KEY': API_KEY
    }

    fetch(`${PROXY}/api/action/contactus`, {
      method: 'POST',
      headers,
      body: payload
    })
      .then((res) => {
        if (res.ok) {
          return res.json()
        }
        if (res.status === 404) {
          return fetch(`${PROXY}/contactus`, { method: 'POST', headers, body: payload }).then((r) => {
            if (r.ok) return r.json()
            throw Error('Failed to submit')
          })
        }
        throw Error('Failed to submit')
      })
      .then(() => {
        setEmail('')
        setMessage('')
        setSubmitted(true)
        alert('Thank you! Your message has been submitted.')
      })
      .catch(() => {
        setErrorMessage('Failed to send your message. Please try again later.')
        alert('Contact request has failed. Please try again.')
      })
      .finally(() => {
        setIsSubmitting(false)
      })
  }

  return (
    <div className="container-fluid" style={{ marginTop: '100px', marginBottom: '40px' }} id="bgcontact">
      <div className="container" id="contactcontain">
        <div className="row shadow" id="contactus" style={{ opacity: '0.99', padding: '30px' }}>
          <article className="col-md-6" style={{ padding: '30px' }} id="contactarticle">
            <h1 className="border-bottom border-dark" style={{ paddingBottom: '10px' }}>Contact Us</h1>
            <p style={{ paddingTop: '15px', lineHeight: '1.6' }}>
              We would love to hear from you. Whether you have feedback on our live platform and AI agents, questions about our features, partnership inquiries, or ideas for what we should build next, please leave us a message.
            </p>
            <p style={{ lineHeight: '1.6' }}>
              Our team actively reviews every message to help shape and improve the Dionyziuz experience.
            </p>
          </article>

          <form className="col-md-6" onSubmit={contactSubmit} id="contactform" style={{ paddingTop: '20px', textAlign: 'left' }}>
            {submitted && (
              <div className="alert alert-success" role="alert">
                Thank you! Your message has been sent successfully.
              </div>
            )}
            {errorMessage && (
              <div className="alert alert-danger" role="alert">
                {errorMessage}
              </div>
            )}
            <div className="form-group">
              <label htmlFor="email">Email:</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="form-control"
                id="email"
                placeholder="name@example.com"
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="message">Message:</label>
              <textarea
                required
                id="message"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                className="form-control"
                rows="5"
                maxLength="500"
                placeholder="Share your thoughts, suggestions, or questions..."
              ></textarea>
              <small className="form-text text-muted text-right">
                {message.length}/500 characters
              </small>
            </div>
            <button
              type="submit"
              className="btn bg-transparent"
              style={{ border: 'grey solid 1px' }}
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Sending...' : 'Send'}
            </button>
          </form>
        </div>
      </div>
    </div>
  )
}

export default ContactUs
